import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import styles from "./SimpleModal.module.scss";
import classnames from "classnames";

export interface ISimpleModal {
  isActive?: boolean;
  onClose?: () => void;
  className?: string;
  children?: React.ReactNode;
  width?: string;
  height?: string;
}
export const SimpleModal: FC<ISimpleModal> = observer((props) => {
  const {
    isActive,
    onClose,
    className,
    children,
    width = "80%",
    height = "80%",
  } = props;

  if (!isActive) {
    return null;
  }
  return (
    <div className={classnames(styles.root, className)}>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.container}>
        <div
          className={styles.main}
          style={{
            width,
            height,
          }}
        >
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
});
